
import { apiClient } from '@/lib/apiClient';

export interface UserEmailConfig {
  fullName: string;
  email: string;
  smtpServer: string;
  smtpPort: number;
  smtpUsername: string;
  smtpPassword: string;
  smtpUseTls: boolean;
  imapServer: string;
  imapPort: number;
  imapEmail: string;
  imapPassword: string;
  imapUseSsl: boolean;
  enableNotifications: boolean;
  notificationFrequency: number | null;
  newLeadNotification: string | null;
  leadUpdateNotification: string | null;
  checkFrequency: number;
}

export interface UserDetails {
  id: number;
  email: string;
  firstName?: string;
  lastName?: string;
  username?: string;
}

export const userEmailConfigApi = {
  getUserDetails: async (userId: number): Promise<UserDetails> => {
    try {
      console.log('📧 Fetching user details for:', userId);
      const response = await apiClient.get(`/rbac/profile/${userId}`);
      return {
        id: response.id,
        email: response.email,
        firstName: response.first_name,
        lastName: response.last_name,
        username: response.username
      };
    } catch (error) {
      console.error('💥 Error fetching user details:', error);
      throw error;
    }
  },
  
  getUserEmailConfig: async (userId: number): Promise<UserEmailConfig> => {
    try {
      console.log('📧 Fetching user email config for:', userId);
      const response = await apiClient.get(`/rbac/profile/${userId}`);
      return {
        fullName: response.email_full_name || `${response.first_name} ${response.last_name}`,
        email: response.email,
        smtpServer: response.smtp_server || '',
        smtpPort: parseInt(response.smtp_port) || 465,
        smtpUsername: response.smtp_username || '',
        smtpPassword: response.smtp_password || '',
        smtpUseTls: response.smtp_use_tls === '1' || response.smtp_use_tls === 1,
        imapServer: response.imap_server || '',
        imapPort: parseInt(response.imap_port) || 993,
        imapEmail: response.imap_email || response.email,
        imapPassword: response.imap_password || '',
        imapUseSsl: response.imap_use_ssl === '1' || response.imap_use_ssl === 1,
        enableNotifications: false,
        notificationFrequency: null,
        newLeadNotification: null,
        leadUpdateNotification: null,
        checkFrequency: 5
      };
    } catch (error) {
      console.error('💥 Error fetching user email config:', error);
      throw error;
    }
  },
};
